// Core
import React, { useState, useEffect } from "react";

// Redux
import { useDispatch } from "react-redux";
import { getUserDetailsRequest } from "../../../../../Redux/Slices/Common/commonSlice";
import { updateStaffDetailsRequest_ADMIN } from "../../../../../Redux/Slices/Admin/adminSlice";

// Custom components
import Button from "Components/Button";
import CustomSelect from "Components/CustomSelect";
import InputBox from "Components/InputBox";
import ErrorMessage from "Components/ErrorMessage";
import { notifySuccess } from "Services/Utils/toastNotification";
import { validateInput } from "Services/Utils/validateInput";

const ProfileSettings = ({ goToNextTab }) => {
  //Initialize redux
  const dispatch = useDispatch();

  // Initial state for form data and errors
  const initialFormData = {
    customerName: "",
    // department: "",
    mobileNumber: "",
    countryCode: "",
    email: "",
  };
  const initialErrors = {};

  // Local states
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState(initialErrors);
  const [userDetails, setUserDetails] = useState({});

  useEffect(() => {
    getUserDetailsRequestCall();
  }, []);

  // To get the user details
  const getUserDetailsRequestCall = () => {
    dispatch(
      getUserDetailsRequest({
        callBack: getUserDetailsCBRequest,
      })
    );
  };

  // To handle the response of getUserDetailsRequest
  const getUserDetailsCBRequest = (data) => {
    setFormData({
      customerName: data?.user_name,
      // department: "",
      mobileNumber: data?.mobile,
      email: data?.email,
      countryCode: data?.country_code,
    });
    setUserDetails(data);
  };

  const settingBoxStyle = {
    border: "1px solid #858485",
    borderRadius: "12px",
    outline: "none",
  };
  const settingLabelStyle = {
    color: "#545454",
    fontSize: "16px",
    fontWeight: "400",
  };
  const buttonTitleStyle = {
    fontSize: "16px",
    fontWeight: "600",
  };

  const buttonStyle = {
    height: "44px",
    width: "170px",
    whiteSpace: "nowrap",
  };

  // const departmentOptions = [
  //   { label: "Department 1", value: "department1" },
  //   { label: "Department 2", value: "department2" },
  // ];

  // const departmentStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     border: "1.5px solid #858485",
  //     borderRadius: "12px",
  //     padding: "4px",
  //     boxShadow: "none",
  //     minHeight: "58px",
  //     height: "61px",
  //     cursor: "pointer",
  //     fontWeight: "600",
  //     fontSize: "18px",
  //     boxShadow: "4px 4px 8px rgba(0, 0, 0, 0.1)",
  //   }),
  //   option: (provided, state) => ({
  //     ...provided,
  //     backgroundColor: state.isSelected
  //       ? "#1F2155"
  //       : state.isFocused
  //       ? "#e9ecef"
  //       : "#fff",
  //     color: state.isSelected ? "#fff" : "#000",
  //     padding: 10,
  //     "&:hover": {
  //       backgroundColor: state.isSelected
  //         ? "#1F2155"
  //         : state.isFocused
  //         ? "#e9ecef"
  //         : "#fff",
  //       color: state.isSelected ? "#fff" : "#000",
  //     },
  //   }),
  //   singleValue: (provided) => ({
  //     ...provided,
  //     color: "#000000",
  //   }),
  //   indicatorSeparator: () => ({
  //     display: "none",
  //   }),
  //   dropdownIndicator: (provided) => ({
  //     ...provided,
  //     color: "#121212",
  //     padding: "0 8px",
  //   }),
  // };

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobileNumber") {
      // Remove any non-digit characters
      const numericValue = value.replace(/\D/g, "");
      setFormData((prevData) => ({
        ...prevData,
        [name]: numericValue,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    // Clear error for the specific field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  // Validate form data based on type
  const handleValidation = () => {
    let validationErrors = {};

    Object.keys(formData).forEach((key) => {
      const error = validateInput(key, formData[key]);
      if (Object.keys(error).length > 0) {
        validationErrors = { ...validationErrors, ...error };
      }
    });

    setErrors(validationErrors);
    return validationErrors;
  };

  // Validate and handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate passwords
    const validationErrors = handleValidation();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      // Submit logic here
      dispatch(
        updateStaffDetailsRequest_ADMIN({
          userId: userDetails?.user_id,
          data: {
            user_name: formData?.customerName,
            // department: formData?.department,
            mobile: formData?.mobileNumber,
            email: formData?.email,
          },
          callBack: updateStaffDetailsRequestCB_ADMIN,
        })
      );
    }
  };

  // To handle the response of updateStaffDetailsRequest_ADMIN
  const updateStaffDetailsRequestCB_ADMIN = () => {
    notifySuccess("Profile settings updated successfully!");
    goToNextTab();
  };

  return (
    <div className="p-4 pt-0">
      <form onSubmit={handleSubmit}>
        <div className="row justify-content-between">
          <div className="input-setting col-5  my-5">
            <InputBox
              disabled = "true"
              label="Customer Name"
              name="customerName"
              required
              value={formData.customerName}
              onChange={handleChange}
              inputStyle={settingBoxStyle}
              labelStyle={settingLabelStyle}
            />
            <ErrorMessage message={errors.customerName} />
          </div>
          <div className="input-setting col-5  my-5">
            <InputBox
              disabled = "true"
              label="Customer Email"
              name="email"
              required
              value={formData.email}
              onChange={handleChange}
              inputStyle={settingBoxStyle}
              labelStyle={settingLabelStyle}
            />
            <ErrorMessage message={errors.email} />
            {/* <label className="departmentLabel">Department *</label>
            <CustomSelect
              options={departmentOptions}
              customStyles={departmentStyles}
              onChange={(value) => {
                setFormData((prevData) => ({
                  ...prevData,
                  department: value?.value,
                }));

                setErrors((prevErrors) => ({
                  ...prevErrors,
                  department: "",
                }));
              }}
            />
            <ErrorMessage message={errors.department} /> */}
          </div>

          <div className="input-setting col-5">
            <InputBox
              label="Customer Mobile Number"
              name="mobileNumber"
              type="tel"
              disabled = "true"
              maxLength={10}
              required
              value={`${formData.countryCode || ''} ${formData.mobileNumber || ''}`}
              onChange={handleChange}
              inputStyle={{ ...settingBoxStyle, appreance: "none" }}
              labelStyle={settingLabelStyle}
            />
            <ErrorMessage message={errors.mobileNumber} />
          </div>
          <div className="input-setting col-5">{/* email area */}</div>
        </div>
        {/* <div className="col-2 mt-5">
          <Button
            title="Submit & Next"
            titleStyle={buttonTitleStyle}
            buttonStyle={buttonStyle}
            forForm
          />
        </div> */}
      </form>
    </div>
  );
};

export default ProfileSettings;
